var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 4.64062V3.51562C19.7812 1.57711 18.2041 0 16.2656 0H7.64062C5.70211 0 4.125 1.57711 4.125 3.51562V4.64062H19.7812Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53125 14.9531V20.6719V21.8906V22.5938C5.53125 23.3704 6.16083 24 6.9375 24H16.9688C17.7454 24 18.375 23.3704 18.375 22.5938V21.8906V20.6719V14.9531H5.53125ZM13.8281 20.9531H10.0781C9.68981 20.9531 9.375 20.6383 9.375 20.25C9.375 19.8617 9.68981 19.5469 10.0781 19.5469H13.8281C14.2164 19.5469 14.5312 19.8617 14.5312 20.25C14.5312 20.6383 14.2164 20.9531 13.8281 20.9531ZM13.8281 17.9531H10.0781C9.68981 17.9531 9.375 17.6383 9.375 17.25C9.375 16.8617 9.68981 16.5469 10.0781 16.5469H13.8281C14.2164 16.5469 14.5312 16.8617 14.5312 17.25C14.5312 17.6383 14.2164 17.9531 13.8281 17.9531Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 6.04688H3.51562C1.57711 6.04688 0 7.62398 0 9.5625V15.1875C0 17.126 1.57711 18.7031 3.51562 18.7031H4.125V14.9531H3.70312C3.31481 14.9531 3 14.6383 3 14.25C3 13.8617 3.31481 13.5469 3.70312 13.5469H4.82812H19.0781H20.2031C20.5914 13.5469 20.9062 13.8617 20.9062 14.25C20.9062 14.6383 20.5914 14.9531 20.2031 14.9531H19.7812V18.7031H20.4375C22.376 18.7031 23.9531 17.126 23.9531 15.1875V9.5625C23.9531 7.62398 22.376 6.04688 20.4375 6.04688ZM5.95312 10.4531H3.70312C3.31481 10.4531 3 10.1383 3 9.75C3 9.36169 3.31481 9.04688 3.70312 9.04688H5.95312C6.34144 9.04688 6.65625 9.36169 6.65625 9.75C6.65625 10.1383 6.34144 10.4531 5.95312 10.4531Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.d659dee591b14e5483573760b3e2fed0.svg";
export { ForwardRef as ReactComponent };